import {LogLevel, Occupancy} from "@variocube/app-api";
import {BoxAccess, MessageView, PushButton, useBox, usePlatform} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {useLocalization} from "../i18n";

interface PickupViewProps {
    occupancy: Occupancy;
    onDone: () => void;
}

export function PickupView({occupancy, onDone}: PickupViewProps) {
    const platform = usePlatform();
    const {t} = useLocalization();
    const box = useBox(occupancy.boxNumber);

    const handleConfirm = useCallback(async () => {
        await platform.log(LogLevel.Audit, "Customer pickup", {occupancy});
        await platform.endOccupancy(occupancy.uuid);
        onDone();
    }, [platform, occupancy, onDone]);

    if (box) {
        return (
            <BoxAccess
                boxes={box}
                platform={platform}
                onCancel={onDone}
                allowCancelWhenOpen
                onConfirm={handleConfirm}
                boxOpenTitle={t("PickupTitle")}
                boxOpenMessage={t("PickupMessage", {boxNames: box.number})}
                confirmTitle={t("PickupConfirmTitle")}
                confirmMessage={t("PickupConfirmMessage", {boxNames: box.number})}
                strings={t}
            />
        )
    }
    else {
        return (
            <MessageView message="Configuration error">
                <PushButton onClick={onDone}>
                    {t("Close")}
                </PushButton>
            </MessageView>
        )
    }
}